import { render, staticRenderFns } from "./invalidTenantModal.vue?vue&type=template&id=eb6e747e"
import script from "./invalidTenantModal.vue?vue&type=script&lang=js"
export * from "./invalidTenantModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports